var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(42, 197, 157)",
    d: "M7.999,16.0 C3.588,16.0 0.0,12.411 0.0,8.0 C0.0,3.588 3.588,0.0 7.999,0.0 C12.410,0.0 16.0,3.588 16.0,8.0 C16.0,12.411 12.410,16.0 7.999,16.0 ZM7.999,0.999 C4.140,0.999 0.999,4.139 0.999,8.0 C0.999,11.860 4.140,15.0 7.999,15.0 C11.858,15.0 14.999,11.860 14.999,8.0 C14.999,4.139 11.858,0.999 7.999,0.999 ZM9.699,13.476 L6.520,13.476 C6.67,13.476 5.701,13.168 5.701,12.715 C5.701,12.263 6.67,11.955 6.520,11.955 L7.223,11.955 L7.223,7.646 L6.568,7.646 C6.116,7.646 5.749,7.211 5.749,6.759 C5.749,6.306 6.116,5.871 6.568,5.871 L8.109,5.871 C8.562,5.871 8.997,6.279 8.997,6.732 L8.997,11.955 L9.699,11.955 C10.151,11.955 10.518,12.263 10.518,12.715 C10.518,13.168 10.151,13.476 9.699,13.476 ZM8.126,4.492 C7.571,4.493 7.139,4.68 7.133,3.515 C7.127,2.956 7.591,2.490 8.143,2.503 C8.684,2.515 9.120,2.967 9.116,3.512 C9.112,4.65 8.682,4.492 8.126,4.492 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo01);
export default __webpack_public_path__ + "static/media/icon_info-01.172fa3c428b1a02fc496e4eac5c219e3.svg";
export { ForwardRef as ReactComponent };